import React from "react";
import List from "components/list";
import { getCompanyBasedColumns } from "./company-columns";
import { getUserFields } from "components/user/config";

export default function CompanyBasedBillableListing({
  status,
  onFiltersChange,
  title = `${status} Billables by Company`,
  filters = () => ({}),
  renderContent = () => { },
  sortOrder,
  sortBy,
  statusWiseFilters = {},
  enableAccordion = false,
  renderExpandedRow,
  expandedRowClassName,
  statusWiseDateFilters,
  deep: customDeep,
}) {
  const fields = [
    "id",
    "name",
    {
      contacts: [
        "id",
        {
          projects: [
            "id",
            "name",
            "project_id",
            getUserFields("sales_coordinator"),
            getUserFields("account_manager"),
            getUserFields("coordinator"),
            {
              jobs: [
                "id",
                "name",
                "type",
                {
                  coordinator: ["id", "first_name", "last_name", "avatar"],
                },
                {
                  billables: [
                    "id",
                    "name",
                    "amount",
                    "adjusted_amount",
                    "currency.id",
                    "currency.budget_rate_inr",
                    "currency.name",
                    "status",
                    "billing_date",
                    "type",
                    "invoice_number",
                    "collected_date",
                    "due_date",
                    "forecast_date",
                    "invoice_date",
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ];

  const deep = {
    contacts: {
      _filter: {
        projects: {
          jobs: {
            billables: {
              status: {
                _eq: status,
              },
              ...statusWiseDateFilters,
            },
          },
        },
      },
      projects: {
        _filter: {
          jobs: {
            billables: {
              status: {
                _eq: status,
              },
              ...statusWiseDateFilters,
            },
          },
        },
        jobs: {
          _filter: {
            billables: {
              status: {
                _eq: status,
              },
              ...statusWiseDateFilters,
            },
          },
          billables: {
            _filter: {
              status: {
                _eq: status,
              },
              ...statusWiseDateFilters,
            },
          },
        },
      },
    },
  };

  return (
    <List
      title={title}
      endPoint="companies"
      filters={{ ...statusWiseFilters, deep }}
      onFiltersChange={onFiltersChange}
      columns={getCompanyBasedColumns(status)}
      meta={{ fields, deep: customDeep || deep }}
      href={null}
      storageKey={`${status}-by-company`}
      sortOrder={sortOrder}
      sortBy={sortBy}
      renderContent={renderContent}
      renderFilters={filters}
      searchPlaceholder="Search Companies"
      enableAccordion={enableAccordion}
      renderExpandedRow={renderExpandedRow}
      expandedRowClassName={expandedRowClassName}
    />
  );
}
